<template>
    <div>
        <div class="footer" id="support_footer">
            <div class="footer_left">
                <i class="icon-company iconmoon"></i>
                {{$t('footer.business')}}<span>bd@trustlook.com</span>
            </div>
            <div class="footer_center">
                <i class="icon-technical iconmoon"></i>
                {{$t('footer.technical')}}<span>saas.support@trustlook.com</span>
            </div>
            <div class="footer_right">
                <p>© Trustlook .Inc</p>
            </div>
        </div>
    </div>

</template>

<script>
    import { downAPPBottom } from "../views/public/validator";
    export default{
        name: 'supportFooter',
        mounted(){
            downAPPBottom('support_footer','80px');
        }
    }
</script>

<style lang="scss" scoped>
  .footer{
      width: 100%;
      height: 80px;
      @include flex-start-center;
      font-size: 12px;
      border-top: 1px solid rgba(210,220,245,1);
      color: rgba(31, 37, 62, 0.6);
      align-items: center;
      box-sizing: border-box;
      padding: 20px 43px 0;
      font-family: Lato-Semibold;
      font-weight: 600;
      @include absolute-left-bottom(0,0);
      z-index: 999;
      .iconmoon{
          font-size: 20px;
          margin-right: 11px;
      }
      span{
          margin-left: 5px;
      }
      .footer_left{
          width: 212px;
          @include flex-align-center;
      }
      .footer_center{
          flex: 1;
          @include flex-align-center;
          margin-left: 67px;
      }
      .footer_right{
          width: 100px;
          text-align: right;
          color: rgba(28, 28, 28, 1);
          font-family: NexaBold;
      }
  }
  @media screen and (max-width:450px){
      .footer{
          padding: 0 24px;
          height: 100px;
          display: block;
          .footer_left{
              float: left;
              clear: left;
              margin-top: 21px;
          }
          .footer_center{
              float: left;
              clear: both;
              margin-left: 0;
              margin-top: 12px;
          }
          .footer_right{
              @include absolute-right-bottom(24px,58px);
              position: absolute;
              bottom: 58px;
              right: 24px;
          }
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/supportFooter.vue